import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TabContainer.html?raw';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import FloatingMenu from '../Floating/Menu';
import { HtmlHelpers, StringHelpers, TabbingHelpers, TranslationHelpers, UrlHelpers } from "../../../more/Helpers";
import { _TabEnabledMixin } from "../../_loadingHelpers/Tabbing";
import "./TabbingTypes";
//import DataItems = require("DataItems");

class TabContainer extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private pages: Array<Tabbing.TabContainerPage> = [];

    primaryButtonMenu: MdsLax<InstanceType<typeof FloatingMenu>>;
    actionButtonMenu: MdsLax<InstanceType<typeof FloatingMenu>>;

    mainContainer: HTMLElement;
    actionBar: HTMLElement;
    containerClasp: HTMLElement;
    contentNode: HTMLElement;
    tabRow: HTMLElement;
    tabRowContainer: HTMLElement;
    contextTabRow: HTMLElement;
    hiddenContainer: HTMLElement;
    fixedBottomContainer: HTMLElement;
    actionBarButtonsContainer: HTMLElement;
    actionBarMenuContainer: HTMLElement;
    tabSwitchMenuBtn: HTMLButtonElement;

    private activePage: Tabbing.TabContainerPage = null;
    private pageHistory: Array<string> = [];
    private dirtyPages: Array<string> = [];
    private isSidebarReady: boolean = false;

    private btnPrimaryMenu: HTMLElement;
    private primaryButtonFurtherEntriesIcon: HTMLElement;
    private primaryButtonLabel: HTMLElement;
    private primaryButtonIcons: HTMLElement;
    private primaryButtonContainer: HTMLElement;

    private _noTabsElement: HTMLElement;

    private globalButtonEntries: Array<Tabbing.GlobalContextbuttonDescriptor> = [];

    name: string = "";
    updateMainTitle: boolean = true;

    _setNameAttr(name: string) {
        this.name = name;
    }

    createTab(config: Tabbing.TabPageDescriptor): boolean {
        return this.placeWidgetIntoTab(config.widget, config);
    }

    changePageName(name: string, newName: string) {
        let page = TabbingHelpers.getExistingTab(name, this.name);
        if (!page) return;

        let index = this.pageHistory.indexOf(page.name);
        if (index != -1) this.pageHistory[index] = newName;

        index = this.dirtyPages.indexOf(page.name);
        if (index != -1) this.dirtyPages[index] = newName;

        index = this.getTabIndexByName(page.name);
        page.name = newName;
        page.sidebarEntryName = newName;

        window.sidebar.changeSubentryName(name, newName);
    }

    private _setUnloadEvent(): void {
        if (this.dirtyPages.length > 0) {
            window.onbeforeunload = function () {
                return "tabs open"; // diese Meldung wird eh nirgends angezeigt... der browser bringt die standardmeldung die man nicht beinflussen kann
            };
        } else {
            window.onbeforeunload = null;
        }
    }

    placeWidgetIntoTab(widget: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>>, preConfig?: Tabbing.TabPageDescriptor): boolean {

        if (!widget || !widget.domNode) return;

        this._setNoTabsMessage(false);

        let isWidgetTabEnabledMixin: boolean = typeof (widget.getContainerName) == "function" && typeof (widget.embedAsTab) == "function";

        this.UiModder.domConstruct.place(widget.domNode, this.hiddenContainer);

        widget["_tabContainer"] = this;

        if (preConfig) {
            if (preConfig.label) {
                preConfig.label = TranslationHelpers.tryTranslate(preConfig.label);
            }
            if (preConfig.groupLabel) {
                preConfig.groupLabel = TranslationHelpers.tryTranslate(preConfig.groupLabel);
            }
        }
        widget.title = TranslationHelpers.tryTranslate(widget.title);

        let name = widget.internalName ? widget.internalName : widget.id;

        let newPage: Tabbing.TabContainerPage = {
            name: name,
            label: widget.title,
            contentNode: widget.domNode,
            enableClosing: widget.enableClosing !== false,
            labelNode: null,
            tabNode: null,
            sidebarNode: null,
            widget: widget,
            groupLabel: widget.title,
            contextButtons: [],
            primaryMenuGroups: [],
            iconclass: widget.iconclass,
            //actionButtons: [],
            //actionMenuButtons: [],
            //topMenuButtons: [],
            actionMenuNode: null,
            topMenuNode: null,
            topMenuContainerNode: null,
            //bottomContextButtons: [],
            sidebarEntryName: widget.showInSidebar ? name : null
        };

        if (preConfig) {
            if (!preConfig.sidebarEntryName) {
                preConfig.sidebarEntryName = preConfig.name;
            }

            for (let property in preConfig) {
                newPage[property] = preConfig[property];
            }
        }

        let cfg = this.createTopContextButton(newPage, {
            callback: lang.hitch(this, this._onClick_TopMenu),
            label: this.createFontawesomeIcon("fas fa-ellipsis-h").outerHTML,
            permanent: false,
            order: 9999,
            placement: "top",
            name: "TopMenu"
        });
        newPage.topMenuNode = cfg.node;

        this.UiModder.domAttr.set(newPage.topMenuNode, "id", "topMenuBtn");


        if (!newPage.actionMenuNode) {

            //this.UiModder.domConstruct.create("div", {
            //    className: "flex_cell_rest"
            //}, this.actionBar, "last");

            let icon = this.createFontawesomeIcon("fas fa-ellipsis-h");
            let cfg = this.createActionButton(newPage, {
                callback: lang.hitch(this, this._onClick_ActionMenu),
                label: icon.outerHTML,
                permanent: false,
                placement: "actionbar",
                name: "-tabcontainerMenu-"
            });
            let menuBtn = cfg.node;
            this.UiModder.domConstruct.place(menuBtn, this.actionBarMenuContainer);
            this.UiModder.domClass.add(menuBtn, "menuBtn w3-hide");
            this.UiModder.domAttr.set(menuBtn, "id", "actionMenuBtn");

            newPage.actionMenuNode = menuBtn;
        }

        this.UiModder.domClass.add(newPage.topMenuNode, "w3-hide hidden");
        this.UiModder.domAttr.set(newPage.topMenuNode, "id", "topMenuBtn");


        // prüfen ob schon vorhanden?
        let existingPage = this.getTabByName(newPage.name);
        if (existingPage) {
            // entfernen? besser abbrechen?
            return false;
        }


        widget.isEmbeddedInTab = true;

        widget.internalName = newPage.name;
        widget.title = newPage.label;

        if (isWidgetTabEnabledMixin) {
            //muss kein Dummy sein, Tabenabled - Mixin hat selber ein Override
            if (!widget.iconclass) widget.iconclass = newPage.iconclass;
        } else {
            // die Funktion kapern:
            widget.setTitles = lang.hitch(this, this._widgetTitleSetter, newPage);
        }

        this.pages.push(newPage);

        this.emit("openPage", newPage.name);

        let tabNode = this.createTabNode(newPage);

        if (newPage.sidebarEntryName) {
            this.createSidebarEntry(newPage);
        }


        if (this.pages.length > 1) {
            this.hideNode(this.tabSwitchMenuBtn, false);
        } else {
            this.hideNode(this.tabSwitchMenuBtn, true);
        }

        on(widget, "requestSwitchTab", lang.hitch(this, this._onRequestSwitchTab));
        on(widget, "requestNewTab", lang.hitch(this, this._onRequestNewTab));
        on(widget, "requestNewContextButton", lang.hitch(this, this._onRequestNewContextButton, newPage));
        on(widget, "requestNewMenuGroup", lang.hitch(this, this._onRequestNewPrimaryMenuGroup, newPage));
        on(widget, "requestDisableContextButton", lang.hitch(this, this._onRequestDisableContextButton, newPage));
        on(widget, "requestRemoveContextButton", lang.hitch(this, this._onRequestRemoveContextButton, newPage));
        //on(widget, "tabClosed", lang.hitch(this, this._onRequestTabclose, newPage.name));
        on(widget, "requestTabRename", lang.hitch(this, this._onRequestTabRename, newPage));
        on(widget, "requestTabRecolor", lang.hitch(this, this._onRequestTabRecolor, newPage));
        on(widget, "busyStart", lang.hitch(this, this._onTabBusy, true, newPage));
        on(widget, "busyEnd", lang.hitch(this, this._onTabBusy, false, newPage));
        on(widget, "dirty", lang.hitch(this, this._onTabDirty, newPage));

        if (widget) {
            try {
                widget.tabColor = newPage.coloration;
            } catch (ex) {

            }

            try {
                if (widget["_onEmbedding"]) {
                    widget._onEmbedding(newPage, this.name);
                }

            } catch (ex) {

            }
        }

        let targetContainerName = UrlHelpers.getUrlParameterValue("tc");

        if (!this.activePage) {
            if (!targetContainerName || newPage.name == targetContainerName) {
                this.activatePage(newPage);
            }
        }

        return true;
    }

    private _widgetTitleSetter(page: Tabbing.TabContainerPage, windowtitle?: string, topbarTitle?: string) {
        this._onRequestTabRename(page, topbarTitle ? topbarTitle : windowtitle);
    }

    private createSidebarEntry(page: Tabbing.TabContainerPage) {
        if (!this.isSidebarReady) return;

        if (page.sidebarNode) {
            this.UiModder.domConstruct.destroy(page.sidebarNode);
        }
        let sidebarEntry = window.sidebar.addEntryToCurrentNavigation({
            label: page.label,
            callback: lang.hitch(this, this._onClick_TabNode, page),
            name: page.sidebarEntryName,
            enableClosing: page.enableClosing,
            iconclass: page.iconclass,
            color: page.coloration
        });

        if (sidebarEntry && sidebarEntry.node) {
            page.sidebarNode = sidebarEntry.node;
        }
    }
    private _createSidebarEntries(): void {
        if (!this.isSidebarReady) {
            return;
        }

        for (let page of this.pages) {
            if (page.sidebarEntryName) {
                this.createSidebarEntry(page);
            }
        }

        if (this.activePage && this.activePage.sidebarEntryName) {
            window.sidebar.activateSubentryByName(this.activePage.name);
        }
    }

    private createActionMenuButton(parentPage: Tabbing.TabContainerPage, config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let page: Tabbing.TabContainerPage = parentPage;
        if (!page) return;

        if (this.isContextButtonCreated(config.name, page, "actionmenu")) {
            this._updateButton(config, parentPage);
            return;
        }
        let buttonConfig: Tabbing.ContextActionButtonDescriptor = {
            ...config,
            node: null
        };
        if (config.permanent) {

            let gConfig: Tabbing.GlobalContextbuttonDescriptor = { ...buttonConfig, sourceTabName: parentPage.name };
            this.globalButtonEntries.push(gConfig);
        } else {
            page.contextButtons.push(buttonConfig);
        }

        //this.UiModder.domClass.remove(page.actionMenuNode, "hidden w3-hide");

        return buttonConfig;
    }


    private createTopMenuEntry(parentPage: Tabbing.TabContainerPage, config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let page: Tabbing.TabContainerPage = parentPage;
        if (!page) return;

        if (this.isContextButtonCreated(config.name, page, "topmenu")) {
            this._updateButton(config, parentPage);
            return;
        }
        let buttonConfig: Tabbing.ContextActionButtonDescriptor = {
            ...config,
            node: null
        };
        if (config.permanent) {
            let gConfig: Tabbing.GlobalContextbuttonDescriptor = { ...buttonConfig, sourceTabName: parentPage.name };
            this.globalButtonEntries.push(gConfig);
        } else {
            page.contextButtons.push(buttonConfig);
        }
    }

    private _onRequestNewPrimaryMenuGroup(parentPage: Tabbing.TabContainerPage, config: Tabbing.PrimaryMenuGroupRequest): Tabbing.PrimaryMenuGroupDescriptor {

        let page: Tabbing.TabContainerPage = parentPage;
        if (!page) return;

        if (this.isPrimaryMenuGroupCreated(config.name, page)) return;

        page.primaryMenuGroups.push(config);

    }

    private createPrimaryMenuEntry(parentPage: Tabbing.TabContainerPage, config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let page: Tabbing.TabContainerPage = parentPage;
        if (!page) return;

        if (this.isContextButtonCreated(config.name, page, "primarymenu")) {
            this._updateButton(config, parentPage);
            return;
        }
        let buttonConfig: Tabbing.ContextActionButtonDescriptor = {
            ...config,
            node: null
        };
        if (config.permanent) {
            let gConfig: Tabbing.GlobalContextbuttonDescriptor = { ...buttonConfig, sourceTabName: parentPage.name };
            this.globalButtonEntries.push(gConfig);
        } else {
            page.contextButtons.push(buttonConfig);
        }


    }

    private _updateButton(config: Tabbing.ContextActionButtonRequest, page: Tabbing.TabContainerPage) {
        if (!page || !config) return;

        for (let button of page.contextButtons) {
            if (button.name == config.name) {
                if (typeof (config.enabled) == "boolean") this.enableButton(config.name, page.name, config.enabled);
                //if (typeof (config.order) == "number") {
                //    this.UiModder.domStyle.set(button.node, "order", config.order);
                //}

                if (config.coloration) {
                    this.applyColorationToNode(button.node, config.coloration);
                }
            }
        }


    }

    private createBottomContextButton(parentPage: Tabbing.TabContainerPage, config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let page: Tabbing.TabContainerPage = parentPage;
        if (!page) return;

        if (this.isContextButtonCreated(config.name, page, "bottombar")) {
            this._updateButton(config, parentPage);
            return;
        }


        let buttonConfig: Tabbing.ContextActionButtonDescriptor = {
            ...config,
            node: null
        };

        if (buttonConfig.permanent) {
            let gConfig: Tabbing.GlobalContextbuttonDescriptor = { ...buttonConfig, sourceTabName: parentPage.name };
            this.globalButtonEntries.push(gConfig);

        } else {
            page.contextButtons.push(buttonConfig);
        }

        let node = this.UiModder.domConstruct.create("div", {
            className: "contextEntry",
            style: {
                "order": typeof (buttonConfig.order) == "number" ? buttonConfig.order : 99
            }

        }, this.fixedBottomContainer);
        

        if (buttonConfig.coloration) {
            this.applyColorationToNode(node, buttonConfig.coloration);
        }
        let label = buttonConfig.label;
        if (buttonConfig.iconClass) {
            let icon = this.createFontawesomeIcon(buttonConfig.iconClass + (!!label ? " labelIcon" : ""), "");
            label = icon.outerHTML + label;
        }
        let selectorButton = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base hoverBright contextButton roundest accentBG",
            "innerHTML": label,
            "title": buttonConfig.heading,
        }, node);

        this.setCyAttribute(buttonConfig, parentPage, "BottomContextBtn", selectorButton);
        this.disableNode(selectorButton, buttonConfig.enabled === false);
        this.UiModder.domClass.toggle(node, "disabled", buttonConfig.enabled === false);

        on(selectorButton, "click", buttonConfig.callback);

        this.UiModder.domClass.toggle(node, "w3-hide", buttonConfig.permanent != true && this.activePage != page);

        buttonConfig.node = node;
    }
    private createTopContextButton(parentPage: Tabbing.TabContainerPage, config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let page: Tabbing.TabContainerPage = parentPage;

        if (!page) return null;

        if (this.isContextButtonCreated(config.name, page, "top")) {
            this._updateButton(config, parentPage);
            return;
        }
        let buttonConfig: Tabbing.ContextActionButtonDescriptor = {
            node: null,
            ...config
        };

        if (buttonConfig.permanent) {
            let gConfig: Tabbing.GlobalContextbuttonDescriptor = { ...buttonConfig, sourceTabName: parentPage.name };
            this.globalButtonEntries.push(gConfig);

        } else {
            page.contextButtons.push(buttonConfig);
        }


        let buttonNode = this.UiModder.domConstruct.create("div", {
            className: "contextEntry",
            style: {
                "order": typeof (buttonConfig.order) == "number" ? buttonConfig.order : 99
            }

        }, this.contextTabRow);
         
        if (buttonConfig.coloration) {
            this.applyColorationToNode(buttonNode, config.coloration);
        }


        let label = buttonConfig.label;
        if (buttonConfig.iconClass) {
            let icon = this.createFontawesomeIcon(buttonConfig.iconClass + (!!label ? " labelIcon" : ""), "");
            label = icon.outerHTML + label;
        }

        let selectorButton = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base hoverBright contextButton",
            "innerHTML": label,
        }, buttonNode);

        this.setCyAttribute(buttonConfig, parentPage, "TopContextBtn", selectorButton);

        this.disableNode(buttonNode, buttonConfig.enabled === false);

        on(selectorButton, "click", buttonConfig.callback);

        this.UiModder.domClass.toggle(buttonNode, "w3-hide", buttonConfig.permanent != true && this.activePage != page);

        buttonConfig.node = buttonNode;

        this._recalcTabOverflow();

        return buttonConfig;
    }

    private isContextButtonCreated(name: string, page: Tabbing.TabContainerPage, placement?: Tabbing.ButtonPlacement): boolean {

        if (!name) return false;

        if (page) {
            for (let config of page.contextButtons) {
                if (config.name == name) {
                    if (!placement || placement == config.placement) {
                        return true;
                    }
                }
            }
        }
        for (let config of this.globalButtonEntries) {
            if (config.name == name) return true;
        }

        return false;
    }

    private isPrimaryMenuGroupCreated(name: string, page: Tabbing.TabContainerPage): boolean {
        if (!name) return false;

        if (page) {
            for (let config of page.primaryMenuGroups) {
                if (config.name == name) return true;
            }
        }

        return false;
    }

    private getPrimaryMenuGroupByName(name: string): Tabbing.PrimaryMenuGroupDescriptor {
        let primaryMenuGroup = null;
        for (let group of this._currentButtonGroups_PrimaryMenu) {
            if (group.name === name) return group;
        }
        return primaryMenuGroup
    }

    private createActionButton(parentPage: Tabbing.TabContainerPage, config: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let page: Tabbing.TabContainerPage = parentPage;
        if (!page) return null;

        if (this.isContextButtonCreated(config.name, page, "actionbar")) {
            this._updateButton(config, parentPage);
            return;
        }
        let buttonConfig: Tabbing.ContextActionButtonDescriptor = {
            ...config,
            node: null
        };



        if (buttonConfig.permanent) {
            let gConfig: Tabbing.GlobalContextbuttonDescriptor = { ...buttonConfig, sourceTabName: parentPage.name };
            this.globalButtonEntries.push(gConfig);

        } else {
            page.contextButtons.push(buttonConfig);
        }

        let actionNode = this.UiModder.domConstruct.create("div", {
            className: "action",
            style: {
                "order": typeof (buttonConfig.order) == "number" ? buttonConfig.order : 99
            }
        }, this.actionBarButtonsContainer);


        //if (config.coloration) {
        //    this.applyColorationToTabNode(tabNode, config.coloration);
        //}
        let label = buttonConfig.label;
        if (buttonConfig.iconClass) {
            let icon = this.createFontawesomeIcon(buttonConfig.iconClass + (!!label ? " labelIcon" : ""), "");
            label = icon.outerHTML + label;
        }
        let selectorButton = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base square hoverBright contextButton",
            "innerHTML": label
        }, actionNode);

        this.setCyAttribute(buttonConfig, parentPage, "ActionBtn", selectorButton);
       
        this.disableNode(actionNode, buttonConfig.enabled === false);

        on(selectorButton, "click", buttonConfig.callback);

        this.UiModder.domClass.toggle(actionNode, "w3-hide", buttonConfig.permanent != true && this.activePage != page);

        buttonConfig.node = actionNode;

        this.hideNode(this.actionBar, false);

        return buttonConfig;
    }

    /** Prüft die Zeile mit den Tabs auf Overflow. Falls Bildschirm zu klein bzw. zu viele Tabs geöffnet, wird der Style umgeschaltet.
     * */
    private _recalcTabOverflow(): void {
        //let rect = this.tabRow.getBoundingClientRect();

        this.UiModder.domClass.remove(this.tabRow, "tabOverflow minimal");
        this.tabRow.style.removeProperty("--maxTabWidth");

        let currentMaxWidth = this.tabRow.clientWidth;
        if (this.tabRow.scrollWidth > currentMaxWidth) {
            this.UiModder.domClass.add(this.tabRow, "tabOverflow");

            // immer noch, weil vielleicht nicht detachable tabs auch noch da sind?
            if (this.tabRow.scrollWidth > currentMaxWidth) {
                this.UiModder.domClass.add(this.tabRow, "tabOverflow minimal");
            }
        }

        if (this.pages.length != 0 && this.pages.length < 5) {
            let newMaxTabWidth = (currentMaxWidth / (this.pages.length + 0.4)).toFixed(0);
            this.tabRow.style.setProperty("--maxTabWidth", newMaxTabWidth + "px");
        }
    }

    private applyColorationToNode(node: HTMLElement, coloration: string) {
        // testen: ist es eine Styleklasse die eine Färbung herbeiführt?
        if (!node) return;
        if (!coloration) {
            node.style.removeProperty("--tabColor");
            node.style.removeProperty("--tabColorTXT");
            this.UiModder.domClass.remove(node, "brightColor");
            return;
        }

        let dummy = this.UiModder.domConstruct.create("div", {}, this.hiddenContainer);
        let css = window.getComputedStyle(dummy);

        let defaultColorBG = css.backgroundColor;
        let defaultColorTxt = css.color;

        this.UiModder.domClass.add(dummy, coloration);
        css = window.getComputedStyle(dummy);

        let bgStyle = coloration;
        let txtStyle = "";

        //console.debug("computed linkstyle", css);

        // hat sich geändert durch die Klasse?
        if (css.backgroundColor != defaultColorBG) {
            bgStyle = css.backgroundColor;
        }

        if (css.color != defaultColorTxt) {
            txtStyle = css.color;
        }

        // so oder so sollten wir jetzt einen Style haben, den wir direkt auf die bg-Color-Variable setzen können
        if (bgStyle) {
            node.style.setProperty("--tabColor", bgStyle);
            try {
                if (!this.isDarkColor(bgStyle)) {
                    this.UiModder.domClass.add(node, "brightColor");
                }
            } catch (ex) {

            }
        }
        if (txtStyle) {
            //this.UiModder.domStyle.set(node, "color", txtStyle);
            node.style.setProperty("--tabColorTXT", txtStyle);
        }

        this.UiModder.domConstruct.destroy(dummy);
    }

    _onTabDirty(config: Tabbing.TabContainerPage, state: boolean) {
        if (config) {
            if (config.tabNode) {
                this.UiModder.domClass.toggle(config.tabNode, "dirty", state === true);
            }
            if (config.sidebarNode) {
                this.UiModder.domClass.toggle(config.sidebarNode, "dirty", state === true);
            }

            let dirtyIndex = this.dirtyPages.indexOf(config.name);
            if (dirtyIndex == -1 && state == true) {
                this.dirtyPages.push(config.name);
            }
            else if (dirtyIndex != -1 && state != true) {
                this.dirtyPages.splice(dirtyIndex, 1);
            }

            this._setUnloadEvent();
        }
    }

    private _onRequestTabRenameGlobal(request: { tabname: string, newTitle: string }) {
        if (!request || !request.tabname || !request.newTitle) return;

        let page = this.getTabByName(request.tabname);
        if (page) this._onRequestTabRename(page, request.newTitle);
    }
    private _onRequestTabRename(config: Tabbing.TabContainerPage, newTitle: string) {
        if (config) {
            let titleWithIcon = newTitle;
            if (config.iconclass) {
                let icon = this.createFontawesomeIcon(config.iconclass + " labelIcon", "");
                titleWithIcon = icon.outerHTML + newTitle;
            }

            if (config.labelNode) {
                this.UiModder.domAttr.set(config.labelNode, "innerHTML", titleWithIcon);
                config.label = newTitle;
            }


            if (config.sidebarNode) {
                window.sidebar?.renameSubentryLabel(config.sidebarEntryName, titleWithIcon);
            }
        }

        this._setTranslatedWindowTitleAttr();
    }
    private _onRequestTabRecolor(config: Tabbing.TabContainerPage, newColor: string) {

        if (config) {
            config.coloration = newColor;
            this.handleColoration();
        }

        this._setTranslatedWindowTitleAttr();
    }
    private _onRequestNewTab(config: Tabbing.TabPageDescriptor) {
        let actualName = config.name;
        if (actualName == "_blank") { // Todo: bessere Typisierung als string | _blank ??
            actualName = (Math.random() * 10000000).toFixed(0);
            config.name = actualName;
        }
        let page = this.getTabByName(config.name);
        if (page) {
            this.switchToTab(page.name);
            return;
        }

        let targetContainerName = config.targetContainerName;
        if (targetContainerName && targetContainerName != this.name) {
            return;
        }
        this.createTab(config);
    }

    private _onRequestDisableContextButton(parentPage: Tabbing.TabContainerPage, data: { name: string, enable: boolean }): boolean {
        let name = data.name;
        let enable = data.enable === true;

        let success = false;


        if (!parentPage || !name) {
            return false;
        }

        for (let i = 0; i < parentPage.contextButtons.length; i++) {
            let config = parentPage.contextButtons[i];

            if (config["_defaultType"] == name || (config.name && config.name == name)) {
                if (config.node) {
                    if (config.placement == "bottombar") {
                        this.UiModder.domClass.toggle(config.node, "disabled", !enable);
                        this.disableNode(config.node.firstChild as HTMLElement, !enable);
                    } else {
                        this.disableNode(config.node, !enable);
                    }


                }
                config.enabled = enable;

                success = true;
            }
        }

        if (success) {
            this.handleButtonVisibility();
        }

        return success;
    }
    private _onRequestRemoveContextButton(parentPage: Tabbing.TabContainerPage, name: string): boolean {
        if (!parentPage || !name) {
            return false;
        }


        let bResult = false;

        for (let i = 0; i < parentPage.contextButtons.length; i++) {
            let config = parentPage.contextButtons[i];

            if (config["_defaultType"] == name || (config.name && config.name == name)) {
                if (config.node) {
                    this.UiModder.domConstruct.destroy(config.node);
                }
                parentPage.contextButtons.splice(i, 1);
                i--;

                bResult = true;
            }
        }

        if (bResult) {
            this.handleButtonVisibility();
        }

        return bResult;
    }

    createButton(config: Tabbing.ContextActionButtonRequest, tabName?: string): boolean {
        let tabWidget = this.activePage?.widget;
        if (tabName) {
            tabWidget = null;
            let page = this.getTabByName(tabName);
            if (page) {
                tabWidget = page.widget;
            }
        }

        if (!tabWidget) return false;

        let result = this.createContextButton(tabWidget, config);
        if (!!result) return true;

        return false;
    }

    removeButton(name: string, tabName?: string): boolean {
        let page = this.activePage;
        if (tabName) {
            page = this.getTabByName(tabName);
        }
        if (!page) return false;

        return this._onRequestRemoveContextButton(page, name);
    }

    enableButton(name: string, tabName?: string, bEnable: boolean = true): boolean {
        let page = this.activePage;
        if (tabName) {
            page = this.getTabByName(tabName);
        }

        if (!page) return false;

        return this._onRequestDisableContextButton(page, { name: name, enable: bEnable === true });
    }

    disableButton(name: string, tabName?: string, bDisable: boolean = true): boolean {
        return this.enableButton(name, tabName, bDisable === false);
    }

    createContextButton(tabWidget: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>>, contextButtonConfig: Tabbing.ContextActionButtonRequest) {
        for (let page of this.pages) {
            if (page.widget == tabWidget) {
                return this._onRequestNewContextButton(page, contextButtonConfig);

            }
        }

        return null;
    }

    createMenuGroup(tabWidget: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>>, primaryMenuGroupConfig: Tabbing.PrimaryMenuGroupRequest) {
        for (let page of this.pages) {
            if (page.widget == tabWidget) {
                return this._onRequestNewPrimaryMenuGroup(page, primaryMenuGroupConfig);
            }
        }

        return null;
    }

    private _onRequestNewContextButton(parentPage: Tabbing.TabContainerPage, contextButtonConfig: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        let result: Tabbing.ContextActionButtonDescriptor = null;
        //if (contextButtonConfig.name == "draft") debugger;

        if (contextButtonConfig && contextButtonConfig.label && !contextButtonConfig.iconClass) {
            // prüfen ob im label ein icon drinsteckt und versuchen rausparsen
            let parseResult = HtmlHelpers.tryParseIconFromLabel(contextButtonConfig.label);

            if (parseResult && parseResult.iconClassResults.length) {
                contextButtonConfig.label = parseResult.cleanElement as string;
                contextButtonConfig.iconClass = parseResult.iconClassResults[0];
            }
        } else if (contextButtonConfig?.label) {
            contextButtonConfig.label = TranslationHelpers.tryTranslate(contextButtonConfig.label);
        }

        if (contextButtonConfig.placement == "actionbar") {
            if (!contextButtonConfig.isDefault) {
                contextButtonConfig.placement = "primarymenu"; // alle Buttons umleiten ins Menü - nur wenige defaultbuttons bleiben
                result = this.createPrimaryMenuEntry(parentPage, contextButtonConfig);
            } else {
                this.createActionButton(parentPage, contextButtonConfig);
            }
        } else if (contextButtonConfig.placement == "bottombar") {
            result = this.createBottomContextButton(parentPage, contextButtonConfig);
        } else if (contextButtonConfig.placement == "actionmenu") {
            result = this.createActionMenuButton(parentPage, contextButtonConfig);
        } else if (contextButtonConfig.placement == "topmenu") {
            result = this.createTopMenuEntry(parentPage, contextButtonConfig);
        } else if (contextButtonConfig.placement == "primarymenu") {
            result = this.createPrimaryMenuEntry(parentPage, contextButtonConfig)
        } else {
            result = this.createTopContextButton(parentPage, contextButtonConfig);
        }

        switch (contextButtonConfig.name as Tabbing.DefaultButtonName) {
            case "new":
            case "save":
            case "submit":
            case "send":
            case "edit":
                let bottomConfig = lang.clone(contextButtonConfig);
                bottomConfig.placement = "bottombar";
                this.createBottomContextButton(parentPage, bottomConfig);
                break;
        }

        this.handleButtonVisibility();

        return result;
    }

    private _onRequestSwitchTab(name: string) {
        this.switchToTab(name);
    }

    private _onRequestTabclose(name: string) {
        /*this.switchToTab(name);*/
        this.destroyPage(name);
    }

    private _onTabBusy(targetState: boolean, page: Tabbing.TabContainerPage) {
        this.UiModder.domClass.toggle(page.tabNode, "busy", targetState);
    }

    switchToTab(name: string): boolean {
        return this.activatePageByName(name);
    }

    isTabAvailable(name: string): boolean {
        let page = this.getTabByName(name);

        return page != null;
    }

    destroyPage(name: string, newTarget?: string): boolean {
        let pageIndex = this.getTabIndexByName(name);
        if (pageIndex == -1) return false;

        let page = this.pages[pageIndex];


        this.hideNode(page.contentNode);
        this.UiModder.domConstruct.destroy(page.tabNode);

        setTimeout(lang.hitch(this, this._destroyPageContent, page), 2000);

        this._onTabDirty(page, false);

        if (page.sidebarNode && this.isSidebarReady) {
            let res = window.sidebar.removeSubentryByName(page.name);
            if (res == false){
                res = window.sidebar.removeSubentryByName(page.sidebarEntryName); //fallback - fuer address wiz
                if (res == false){
                    console.warn("cannot remove page from sidebar", page);
                }
            }
            this.UiModder.domConstruct.destroy(page.sidebarNode);
        }


        if (this.globalButtonEntries && this.globalButtonEntries.length) {
            let newArray = [];
            for (let buttonConfig of this.globalButtonEntries) {
                if (buttonConfig.sourceTabName == name) {
                    if (buttonConfig.node) this.UiModder.domConstruct.destroy(buttonConfig.node);
                } else {
                    newArray.push(buttonConfig);
                }
            }

            this.globalButtonEntries = newArray;
        }

        this.pages.splice(pageIndex, 1);

        this.emit("closePage", page.name);

        if (this.pages.length <= 1) {
            this.hideNode(this.tabSwitchMenuBtn, true);
            this._setNoTabsMessage();
        }
        if (newTarget) {

            this.switchToTab(newTarget);
        } else {
            while (this.pageHistory.length) {
                let previousPageName = this.pageHistory.pop();
                if (this.switchToTab(previousPageName) == true) {
                    break;
                }
            }
        }

        this._recalcTabOverflow();

        return true;
    }

    private _setNoTabsMessage(bShow?: boolean) {
        if (bShow === false) {

            if (this._noTabsElement) {
                this.UiModder.domConstruct.destroy(this._noTabsElement);
                this._noTabsElement = null;
            }

            return;
        }

        if (this._noTabsElement) return;

        let p = this.UiModder.domConstruct.create("p", {
            className: "w3-large",
            innerHTML: TranslationHelpers.translate("Tabbing__NoTabsAvailable")
        }, this.contentNode);

        let icon = HtmlHelpers.createFontawesomeIcon("fas fa-meh", true, p, "first");

        this._noTabsElement = p;
    }

    private _destroyPageContent(page: Tabbing.TabContainerPage) {
        try {
            page.widget.destroy();
            this.UiModder.domConstruct.destroy(page.contentNode);
            console.log(this.id + " DESTROYED page", page)
        } catch (ex) {


        }


    }

    activatePageByName(name: string): boolean {
        //console.trace("activatePageByName", name);
        //if (this.activePage?.name == name) return true;

        let page = this.getTabByName(name);
        return this.activatePage(page);
    }
    activatePage(page: Tabbing.TabContainerPage): boolean {
        if (!page) return false;
        let previousPageName = this.activePage?.name;


        this.hidePage();
        let widget: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>> = page.widget;
        if (widget) {
            try {
                widget._onActivated();

            } catch (ex) {
                console.warn(widget.id + " is not a tabbing enabled widget. cannot call _onActivated!\r\n" + ex);
            }

            widget.isActivatedTab = true;
            this.UiModder.domConstruct.place(widget.domNode, this.contentNode);
            window.scroll({ top: 0, behavior: "smooth" });
        }


        if (this.isSidebarReady) {
            if (page.sidebarEntryName) {
                window.sidebar.activateSubentryByName(page.sidebarEntryName);
            } else {
                window.sidebar.activateSubentryByName("----xx----");
            }
        }

        this.activePage = page;


        if (previousPageName != page.name) {
            this.emit("switchPage", page.name);
        }

        //this.removeUrlParameter("tc");
        if (!page.enableClosing && page.name) {
            UrlHelpers.setUrlParameter("tc", page.name);
        }

        this.handleButtonVisibility();
        this.handleColoration();

        this.pageHistory.push(page.name);

        this._setTranslatedWindowTitleAttr();

        this._recalcTabOverflow();

        this._setNoTabsMessage(false);

        return true;
    }

    private handleColoration(targetPage?: Tabbing.TabContainerPage): void {
        let page = targetPage;
        if (!page) page = this.activePage;

        this.applyColorationToNode(page.tabNode, page.coloration);

        if (page == this.activePage) {

            if (page.coloration) {
                let colorValue = page.tabNode.style.getPropertyValue("--tabColor");
                let txtColorValue = page.tabNode.style.getPropertyValue("--tabColorTXT");
                this.contentNode.style.setProperty("--containerColor", colorValue);
                //this.contentNode.style.setProperty("color", txtColorValue);

                this.containerClasp.style.setProperty("--containerColor", colorValue);
                this.containerClasp.style.setProperty("--containerColorTXT", txtColorValue);

                this.contextTabRow.style.setProperty("--tabColor", colorValue);
                this.contextTabRow.style.setProperty("--tabColorTXT", txtColorValue);

                let rgb = this.getRgbFromString(colorValue);
                //let rgb = this.cssRgbToRgb(colorValue);
                if (rgb.length == 3) {
                    this.actionBar.style.setProperty("--actionBarColor", this.stringFormat("rgba({0}, {1}, {2}, {3})", rgb[0]?.toString(), rgb[1]?.toString(), rgb[2]?.toString(), "0.2"));
                }

                this.applyColorationToNode(this.fixedBottomContainer, colorValue);
                this.fixedBottomContainer.style.setProperty("--tabColorTXT", txtColorValue);


            } else {
                this.contentNode.style.removeProperty("--containerColor");
                //this.contentNode.style.removeProperty("color");

                this.containerClasp.style.removeProperty("--containerColor");
                this.containerClasp.style.removeProperty("--containerColorTXT");
                this.containerClasp.style.removeProperty("color");

                this.contextTabRow.style.removeProperty("--tabColor");
                this.contextTabRow.style.removeProperty("--tabColorTXT");

                this.actionBar.style.removeProperty("--actionBarColor");

                this.applyColorationToNode(this.fixedBottomContainer, null);

            }
        }
    }

    /**
     * Räumt Menüeinträge so auf, dass ein einzelner Menügruppeneintrag zur "Hauptebene" hochgehoben wird.
     * Falls es einen solchen einzelnen Gruppeneintrag gibt, wird dieser aus der zu verarbeitendenen Buttonregistry entfernt und retourgegeben.
     */
    private cleanupSingleMenuGroup(): Tabbing.PrimaryMenuGroupDescriptor {
        let firstLevelGroup: Array<Tabbing.PrimaryMenuGroupDescriptor> = [];
        let firstLevelEntries = this._currentButtons_PrimaryMenu?.filter(entry => !entry.groupName);
        if (this._currentButtonGroups_PrimaryMenu.length && !firstLevelEntries?.length) {
            for (let group of this._currentButtonGroups_PrimaryMenu) {
                // nur oberste Gruppenebene und wenn Einträge vorhanden!
                if (group.hasNextLevel && this.groupHasEntries(group, -1) && !group.parentGroupName) {
                    firstLevelGroup.push(group);
                }
            }


            if (firstLevelGroup.length == 1) {


                // also es ist so. wir haben keine Buttons, sondern nur eine registrierte Gruppe an Ebene 0 mit Untereinträgen.
                // die oberste Gruppe lösen wir auf
                // - aus den currentgroups rauskicken
                // - alle currentbuttons mit Verweis auf die Gruppe (groupname) haben dann KEINE Gruppe mehr
                // - alle currentgroups mit Verweis auf die Gruppe (parentgroup) haben auch KEINE Gruppe mehr

                let singleGroup = firstLevelGroup[0];

                let newGroups: Array<Tabbing.PrimaryMenuGroupDescriptor> = [];
                let newPrimaryEntries: Array<Tabbing.ContextActionButtonDescriptor> = [];

                for (let group of this._currentButtonGroups_PrimaryMenu) {
                    if (group.name == singleGroup.name) {
                        // weglassen - die Gruppe wird aufgelöst
                    } else {
                        if (group.parentGroupName == singleGroup.name) {
                            let copy = lang.clone(group);
                            copy.parentGroupName = null;
                            newGroups.push(copy);
                        } else {
                            newGroups.push(group);
                        }
                    }
                }


                for (let primaryActionButton of this._currentButtons_ActionBar) {
                    if (primaryActionButton.groupName == singleGroup.name) {
                        let copy = lang.clone(primaryActionButton);
                        copy.groupName = null;
                        newPrimaryEntries.push(copy);
                    } else {
                        newPrimaryEntries.push(primaryActionButton);
                    }
                }

                this._currentButtons_ActionBar = newPrimaryEntries;
                this._currentButtonGroups_PrimaryMenu = newGroups;

                return singleGroup;
            }
        }

    }

    private handleButtonVisibility(): void {
        let page = this.activePage;
        if (!page) return;

        // Buttons permanent und nicht permanent sammeln:
        this._currentButtons_ActionBar = [];
        this._currentButtons_ActionMenu = [];
        this._currentButtons_Context = [];
        this._currentButtons_TopMenu = [];
        this._currentButtons_PrimaryMenu = [];
        this._currentButtonGroups_PrimaryMenu = [];

        if (page.primaryMenuGroups && page.primaryMenuGroups.length) {
            for (let groupConfig of page.primaryMenuGroups) {
                this._currentButtonGroups_PrimaryMenu.push(groupConfig);
            }
        }

        if (page.contextButtons && page.contextButtons.length) {
            for (let buttonConfig of page.contextButtons) {
                switch (buttonConfig.placement) {
                    case "actionbar":
                        this._currentButtons_ActionBar.push(buttonConfig);
                        break;

                    case "actionmenu":
                        this._currentButtons_ActionMenu.push(buttonConfig);
                        break;

                    case "bottombar":
                    case "top":
                        this._currentButtons_Context.push(buttonConfig);
                        break;

                    case "topmenu":
                        this._currentButtons_TopMenu.push(buttonConfig);
                        break;
                    case "primarymenu":
                        this._currentButtons_PrimaryMenu.push(buttonConfig);
                        break;
                }
            }
        }

        if (this.globalButtonEntries && this.globalButtonEntries.length) {
            for (let buttonConfig of this.globalButtonEntries) {
                if (buttonConfig.node) {
                    this.hideNode(buttonConfig.node, true);
                }

                if (true) {
                    switch (buttonConfig.placement) {
                        case "actionbar":
                            // eine Ausnahme: das Menü ist zwar auch ein Actionbutton, aber mit Sonderregel für die Anzeige
                            if (buttonConfig.node && buttonConfig.node.id != "actionMenuBtn") {
                                this._currentButtons_ActionBar.push(buttonConfig);
                            }
                            break;

                        case "actionmenu":
                            this._currentButtons_ActionMenu.push(buttonConfig);
                            break;

                        case "bottombar":
                        case "top":
                            this._currentButtons_Context.push(buttonConfig);
                            break;

                        case "topmenu":
                            this._currentButtons_TopMenu.push(buttonConfig);
                            break;
                        case "primarymenu":
                            this._currentButtons_PrimaryMenu.push(buttonConfig);
                            break;
                    }
                }
            }
        }


        let singleGroupEntry = this.cleanupSingleMenuGroup();

        if (page.tabNode) {
            this.UiModder.domClass.add(page.tabNode, "active");
        }

        if (page.actionMenuNode) {
            this.hideNode(page.actionMenuNode, this._currentButtons_ActionMenu.length == 0);
        }

        if (page.topMenuNode) {
            this.hideNode(page.topMenuNode, this._currentButtons_TopMenu.length == 0);
        }

        if (this._currentButtons_Context.length) {
            for (let buttonConfig of this._currentButtons_Context) {
                if (buttonConfig.node && buttonConfig.node.id != "topMenuBtn") {
                    this.UiModder.domClass.remove(buttonConfig.node, "w3-hide");
                }
            }
        }

        if (this._currentButtons_ActionBar.length) {
            for (let buttonConfig of this._currentButtons_ActionBar) {
                if (buttonConfig.node && buttonConfig.node.id != "actionMenuBtn") {
                    this.UiModder.domClass.remove(buttonConfig.node, "w3-hide");
                }
            }
        }


        //Empty button and menu container of primary menu
        //this.UiModder.domConstruct.empty(this.btnPrimaryMenu);
        this.hideNode(this.primaryButtonFurtherEntriesIcon);
        this.UiModder.domConstruct.empty(this.primaryButtonIcons);
        this.hideNode(this.btnPrimaryMenu, true);
        this.UiModder.domConstruct.empty(this.primaryButtonContainer);


        //Get PrimaryButtonContainer ButtonGroups
        let buttonEntries: Array<{ order: number, label: string, iconClass: string }> = [];

        let menuIcons: Array<string> = [];
        let singleButtonCallback: Function = null;



        // alle icons zusammenstellen:
        if (this._currentButtonGroups_PrimaryMenu) {
            for (let groupEntry of this._currentButtonGroups_PrimaryMenu) {
                // nur Elemente an Hauptebene, mit Unterelementen
                if (groupEntry.hasNextLevel && !groupEntry.parentGroupName && this.groupHasEntries(groupEntry, -1)) {
                    buttonEntries.push({
                        iconClass: groupEntry.iconClass,
                        order: 666,
                        label: groupEntry.label
                    });
                }
            }
        }

        if (this._currentButtons_PrimaryMenu.length) {
            for (let entry of this._currentButtons_PrimaryMenu) {
                var group = this.getGroup(entry.groupName);
                if (!group || group && !group.hasNextLevel) {
                    singleButtonCallback = entry.callback;
                    buttonEntries.push({
                        iconClass: entry.iconClass,
                        order: entry.order,
                        label: entry.label
                    });
                }

            }
        }

        buttonEntries.sort((a, b) => {
            if (a.order !== null && b.order !== null) {
                return a.order - b.order;
            }
        });


        this.hideNode(this.btnPrimaryMenu, buttonEntries.length <= 1);
        this.hideNode(this.primaryButtonLabel, true);
        this.hideNode(this.primaryButtonIcons, true);
        this.UiModder.domClass.toggle(this.primaryButtonIcons, "icongrid", false);


        if (buttonEntries.length) {

            let iconElements: Array<HTMLElement> = [];

            if (buttonEntries.length > 1) {
                let bDisplayFurtherIcon = false;
                let count = 0;

                // wenn es eine einzelne Gruppe gibt, dann diese für die Buttonbeschriftung nutztn:
                if (singleGroupEntry?.label) {
                    this.primaryButtonLabel.innerText = singleGroupEntry.label;
                    this.hideNode(this.primaryButtonLabel, false);

                    if (singleGroupEntry.iconClass) {
                        let iconContainerNode = this.UiModder.domConstruct.create("span", {
                            className: "iconContainer"
                        }, this.primaryButtonIcons);

                        let iconNode = HtmlHelpers.createFontawesomeIcon(singleGroupEntry.iconClass, false, iconContainerNode);
                        this.hideNode(this.primaryButtonIcons, false);

                    }
                }
                else {
                    for (let grp of buttonEntries) {
                        count++;

                        if (count <= 5) {
                            if (grp.iconClass) {
                                let iconContainerNode = this.UiModder.domConstruct.create("span", {
                                    className: "iconContainer",
                                    order: grp.order
                                }, this.primaryButtonIcons);


                                let iconNode = HtmlHelpers.createFontawesomeIcon(grp.iconClass, false, iconContainerNode);
                                this.hideNode(this.primaryButtonIcons, false);
                            } else {
                                bDisplayFurtherIcon = true;
                            }

                        } else {
                            bDisplayFurtherIcon = true;
                            break;
                        }
                    }

                    this.hideNode(this.primaryButtonLabel, count != 1);

                    this.UiModder.domClass.toggle(this.primaryButtonIcons, "icongrid", buttonEntries.length > 1);

                }

                this.hideNode(this.primaryButtonFurtherEntriesIcon, !bDisplayFurtherIcon);


            } else {
                var button = this._currentButtons_PrimaryMenu[0];

                let label = button.label;
                if (button.iconClass) {
                    let icon = this.createFontawesomeIcon(button.iconClass + " labelIcon", "");
                    label = icon.outerHTML + label;
                }
                let selectorButton = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base square hoverBright contextButton",
                    "innerHTML": label
                }, this.primaryButtonContainer);

                button.node = selectorButton;

                this.disableNode(selectorButton, !button.enabled);
                this.setCyAttribute(button, page, "BottomContextBtn", selectorButton);

                on(selectorButton, "click", button.callback);
            }
        }

        if (this.primaryButtonMenu && !this.primaryButtonMenu._destroyed) this._renderPrimaryButtonEntries();
        if (this.actionButtonMenu && !this.actionButtonMenu._destroyed) this._renderActionMenuEntries();

    }

    private getGroup(groupName: string): Tabbing.PrimaryMenuGroupDescriptor {
        for (var group of this._currentButtonGroups_PrimaryMenu) {
            if (group.name === groupName) return group;
        }
    }

    private groupHasEntries(group: Tabbing.PrimaryMenuGroupDescriptor, includeSubEntryLevels: number = 0): boolean {
        return this.groupGetEntries(group, includeSubEntryLevels)?.length > 0;
    }
    private groupGetEntries(group: Tabbing.PrimaryMenuGroupDescriptor, includeSubEntryLevels: number = 0): Array<Tabbing.ContextActionButtonDescriptor> {
        let entries = [];
        for (var entry of this._currentButtons_PrimaryMenu) {
            if (entry.groupName === group.name) entries.push(entry);
        }
        // bei Level 0 stehen bleiben; bei Level -1 oder drunter einfach immer weiter!
        if (group.hasNextLevel && (includeSubEntryLevels >= 1 || includeSubEntryLevels < 0)) {

            for (let sub of this._currentButtonGroups_PrimaryMenu) {
                if (sub.parentGroupName == group.name) {
                    let subEntries = this.groupGetEntries(sub, includeSubEntryLevels - 1);
                    entries = entries.concat(subEntries);
                }
            }
        }
        return entries
    }

    private getTabIndexByName(name: string): number {
        for (let index = 0; index < this.pages.length; index++) {
            let page = this.pages[index];
            if (page.name == name) {
                return index;
            }
        }
        //fallback - sidebar name
        for (let index = 0; index < this.pages.length; index++) {
            let page = this.pages[index];
            if (typeof page.sidebarEntryName == 'string'){
                if (page.sidebarEntryName == name) {
                    return index;
                }
            }
        }
        return -1;
    }
    getTabPages(): Array<Tabbing.TabContainerPage> {
        return this.pages;
    }
    getActivePage(): Tabbing.TabContainerPage {
        return this.activePage;
    }
    getTabByName(name: string): Tabbing.TabContainerPage {
        let index = this.getTabIndexByName(name);

        if (index != -1) return this.pages[index];
    }

    private createTabNode(page: Tabbing.TabContainerPage) {

        if (page.tabNode) this.UiModder.domConstruct.destroy(page.tabNode);

        let widget: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>> = page.widget;
        let tabNode = this.UiModder.domConstruct.create("div", {
            className: "tab _new",
            /*style: { "order": this.pages.length }*/
        }, this.tabRow);


        setTimeout(lang.hitch(this, this.UiModder.domClass.remove, tabNode, "_new"), 1);


        let selectorButton = this.UiModder.domConstruct.create("button", {
            className: "hoverBright pageSelector",
            "innerHTML": page.label
        }, tabNode);

        this.setCyAttribute(selectorButton, page, "BottomContextBtn:pageSelector", selectorButton);

        if (page.iconclass) {
            let icon = this.createFontawesomeIcon(page.iconclass + " labelIcon", "");
            this.UiModder.domConstruct.place(icon, selectorButton, "first");
        }

        let spinner = this.createFontawesomeIcon("fas fa-circle-notch fa-spin spinner");
        this.UiModder.domConstruct.place(spinner, selectorButton, "first");

        on(selectorButton, "click", lang.hitch(this, this._onClick_TabNode, page));

        if (page.enableClosing === true) {

            this.UiModder.domClass.add(tabNode, "detachable");

            let closeButton = this.UiModder.domConstruct.create("button", {
                id: "",
                className: "closeBtn",
                "innerHTML": "",
                style: {}
            }, tabNode, "last");

            this.createFontawesomeIcon("fas fa-times", "", closeButton);

            this.setCyAttribute(closeButton, page, "BottomContextBtn:Close", closeButton);


            on(closeButton, "click", lang.hitch(this, this._onClick_TabClose, page));
        }

        if (page.coloration) {
            this.applyColorationToNode(tabNode, page.coloration);
            page.coloration = tabNode.style.getPropertyValue("--tabColor");
            page.colorationTXT = tabNode.style.getPropertyValue("--tabColorTXT");
        }

        page.tabNode = tabNode;
        page.labelNode = selectorButton;

        this._recalcTabOverflow();

        return selectorButton;
    }

    private _onClick_TabNode(tabpage: Tabbing.TabContainerPage, evt: MouseEvent) {

        //if (this.activePage?.name == pageName) return;
        if (this.activePage?.name == tabpage?.name) return;

        let page = this.getTabByName(tabpage.name);
        //if (page) this.activatePage(page);
        if (tabpage) this.activatePage(tabpage);
    }

    private _onClick_TabClose(tabpage, args: Array<any>) {

        let page = this.getTabByName(tabpage.name);
        let result = true;



        if (args && args.length > 0) {
            args[0].stopPropagation();
        }

        // versuchen dem Widget den CloseRequest auszuführen

        try {
            let tabMixin: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>> = page.widget;
            if (tabMixin._onCloseRequest) {
                result = tabMixin._onCloseRequest();
            }
            // das Widget meldet sich mit einem Ergebnis: true - darf schließen, false - nicht schließen (zb ungespeicherte Änderungen!)

        } catch (ex) {

        }
        // darf nicht schließen - Benutzerabfrage?
        if (result != true) {
            this.switchToTab(page.name);
            return;
        }

        if (result === true) {
            if (page) {
                if (typeof (page.widget?._onClosing) == "function") {
                    try {
                        page.widget._onClosing();
                    }
                    catch (ex) {

                    }
                } else {
                    console.warn(page.widget.id + " is not tabEnabledMixin - cannot execute onClosing");
                }

            }
            if (this.destroyPage(page.name) == true || this.destroyPage(page.sidebarEntryName) == true) {

            }
        }
    }

    private _onClick_TabSwitchMenu(evt: MouseEvent) {
        let menu = new FloatingMenu();
        let countCloseable = 0;

        for (let page of this.pages) {
            let isDirty = this.dirtyPages.indexOf(page.name) != -1;

            menu.addEntry({
                callback: lang.hitch(this, this._onRequestSwitchTab, page.name),
                label: page.label,
                coloration: page.coloration,
                enabled: page.name == this.activePage.name ? "selected" : page.name != this.activePage.name,
                icon: page.name == this.activePage.name ? "fas fa-eye" : isDirty ? "fas fa-asterisk" : page.iconclass,
                heading: page.groupLabel != page.label ? page.groupLabel : null
            });

            if (page.enableClosing && !isDirty) countCloseable++;
        }


        menu.addEntry({
            callback: lang.hitch(this, this._closeAllPages),
            label: "Tabbing_CloseAllPages",
            groupname: "_internal_closeall",
            enabled: countCloseable > 0,
            icon: "fas fa-times",
        });

        menu.open(evt, null, this._sectionTitle);
    }

    //private _markPreviousPage(targetPage: Tabbing.TabContainerPage) {
    //    for (let page of this.pages) {
    //        if (page.tabNode) {
    //            this.UiModder.domClass.remove(page.tabNode, "previouslyActive");
    //        }
    //    }

    //    if (targetPage.tabNode) {
    //        this.UiModder.domClass.add(targetPage.tabNode, "previouslyActive");
    //    }
    //}

    private hidePage(page?: Tabbing.TabContainerPage) {
        if (!page) {
            page = this.activePage;
        }

        if (!page) return;

        let widget: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>> = page.widget;
        if (widget && !widget._destroyed) {
            try {
                widget._onHide();
            } catch (ex) {
                console.warn(widget.id + " is not a tabbing enabled widget. cannot call _onHide!\r\n" + ex);
            }

            widget.isActivatedTab = false;
            this.UiModder.domConstruct.place(widget.domNode, this.hiddenContainer);
        }

        //this._markPreviousPage(page);
        if (page.tabNode) {
            this.UiModder.domClass.remove(page.tabNode, "active");
        }

        if (page.topMenuNode) {
            this.hideNode(page.topMenuNode, true);
        }

        if (page.actionMenuNode) {
            this.hideNode(page.actionMenuNode, true);
        }

        if (page.contextButtons.length) {
            for (let buttonConfig of page.contextButtons) {
                if (buttonConfig.permanent != true) {
                    if (buttonConfig.node) {
                        this.UiModder.domClass.add(buttonConfig.node, "w3-hide");
                    }
                }
            }
        }

    }

    private _closeAllPages() {
        let pagesToclose = this.pages.filter(page => page.enableClosing == true && this.dirtyPages.indexOf(page.name) == -1);
        for (let page of pagesToclose) {
            this._onRequestTabclose(page.name);
        }
    }

    private _onGlobalClick(evt) {
        //this._onClick_TopMenu(null, false);
    }
    private _onClick_TopMenuEntry(buttonConfig: Tabbing.ContextActionButtonDescriptor) {
        if (buttonConfig) {
            buttonConfig.callback();
        }
    }
    private _onClick_ActionMenu(evt: MouseEvent) {
        if (this.activePage && this._currentButtons_ActionMenu.length) {
            this.actionButtonMenu = new FloatingMenu();

            this._renderActionMenuEntries();

            this.actionButtonMenu.open(evt);
        }
    }

    private _renderActionMenuEntries(): void {
        if (!this.actionButtonMenu._destroyed) this.actionButtonMenu.clearEntries();

        for (let btn of this._currentButtons_ActionMenu) {
            this.actionButtonMenu.addEntry({
                callback: btn.callback,
                label: btn.label,
                coloration: btn.coloration,
                heading: btn.heading,
                icon: btn.iconClass,
                enabled: btn.enabled !== false
            });
        }
    }

    private _onClick_ButtonMenu(e: Event): void {
        if (this.activePage && this._currentButtons_PrimaryMenu.length) {
            this.primaryButtonMenu = new FloatingMenu();

            this._renderPrimaryButtonEntries();

            this.primaryButtonMenu.open(e);
        }
    }

    private _renderPrimaryButtonEntries(): void {
        if (!this.primaryButtonMenu._destroyed) this.primaryButtonMenu.clearEntries();

        for (let grp of this._currentButtonGroups_PrimaryMenu) {
            this.primaryButtonMenu.addGroup(grp.name, grp.label, grp.iconClass, grp.hasNextLevel, grp.parentGroupName);
        }

        for (let btn of this._currentButtons_PrimaryMenu) {
            this.primaryButtonMenu.addEntry({
                callback: btn.callback,
                label: btn.label,
                coloration: btn.coloration,
                heading: btn.heading,
                icon: btn.iconClass,
                enabled: btn.enabled,
                groupname: btn.groupName,
                order: btn.order
            });
        }

        this.primaryButtonMenu.sortEntriesByOrder();
    }

    private _currentButtons_TopMenu: Array<Tabbing.ContextActionButtonDescriptor> = [];
    private _currentButtons_Context: Array<Tabbing.ContextActionButtonDescriptor> = [];
    private _currentButtons_ActionBar: Array<Tabbing.ContextActionButtonDescriptor> = [];
    private _currentButtons_ActionMenu: Array<Tabbing.ContextActionButtonDescriptor> = [];
    private _currentButtons_PrimaryMenu: Array<Tabbing.ContextActionButtonDescriptor> = [];
    private _currentButtonGroups_PrimaryMenu: Array<Tabbing.PrimaryMenuGroupDescriptor> = [];

    private _onClick_TopMenu(evt: MouseEvent, targetState?: boolean) {

        if (this._currentButtons_TopMenu) {
            let menu = new FloatingMenu();
            for (let btn of this._currentButtons_TopMenu) {
                menu.addEntry({
                    callback: btn.callback,
                    label: btn.label,
                    coloration: btn.coloration,
                    heading: btn.heading,
                    icon: btn.iconClass
                });
            }

            menu.open(evt);
        }
    }

    private closeAllTabs() {

    }

    private _sectionTitle: string = "?section";

    private _setHeadingAttr(str: string) {
        this._setTranslatedWindowTitleAttr(str);
    }

    private _setContainerTitleAttr(str: string) {
        this._setTranslatedWindowTitleAttr(str);
    }
    private _setTranslatedWindowTitleAttr(translationString?: string) {

        if (translationString) {
            this._sectionTitle = TranslationHelpers.tryTranslate(translationString);
        }

        // Zusammenstellen: Tab - Section - Maintitle
        let fullTitle = "";
        let shortTitle = "";

        let page = this.activePage;

        if (page) {
            fullTitle = page.label + " - ";
            shortTitle = page.label;
        } else {
            shortTitle = this._sectionTitle;
        }

        fullTitle += this._sectionTitle;

        if (this.updateMainTitle) {
            this.setTitles(fullTitle, shortTitle);
        }
    }

    private _onSidebarCreated(links: Array<any>) {
        if (this.isSidebarReady != true) {
            on(window.sidebar, "requestClose", lang.hitch(this, this._onClick_TabClose));
            this.isSidebarReady = true;
        }

        this._createSidebarEntries();
    }

    private _onClick_ScrollToTop(evt: MouseEvent) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this._displaySrollToTop(false);
    }
    private _windowScrollHandle: any = null;

    private _onWindowScroll(args?: any) {
        if (this._windowScrollHandle != null) {
            clearTimeout(this._windowScrollHandle);
        }

        this._windowScrollHandle = setTimeout(lang.hitch(this, this._displaySrollToTop), 200);
    }

    private _displaySrollToTop(bDisplay?: boolean) {
        if (this._windowScrollHandle != null) {
            clearTimeout(this._windowScrollHandle);
        }

        if (typeof this.fixedBottomContainer != 'undefined') { //null check wegen edge-case webkit
            this.UiModder.domClass.toggle(this.fixedBottomContainer, "hidden", bDisplay === false || window.scrollY < 100);
        }
    }
    private scrollEvent: any = null;

    private actionBarVisibilityRegister: Record<string, boolean> = {};
    private _onSwitchPageManageHideUnHideActionBar(){
        let currentPageName = this.activePage?.name;
        if (typeof currentPageName == 'undefined' || currentPageName == null){
            return; //nix machen wenn kein page name
        }
        if (this.actionBarVisibilityRegister.hasOwnProperty(currentPageName) == false){
            this.actionBarVisibilityRegister[currentPageName] = true; //standard immer visible
        }
        //visibility setzen
        this.toggleVisibilityForButtonBar(this.actionBarVisibilityRegister[currentPageName], currentPageName);
    }

    /**
     * Versteckt einfach die Action Bar. (pro Tab)
     * Achtung: Die Buttons auf der Action Bar werden trozdem nicht disabled (nur ausgeblendet)!
     * @param isVisible Ob die Action Bar angezeigt werdne soll
     */
    public toggleVisibilityForActionBar(isVisible:boolean):void{
        let currentPageName = this.activePage?.name;
        if (typeof currentPageName == 'undefined' || currentPageName == null) {
            return; //nix machen wenn kein page name
        }
        let vis = isVisible == true;
        this.actionBarVisibilityRegister[currentPageName] = vis;
        this.toggleVisibilityForButtonBar(vis, currentPageName);
    }

    private toggleVisibilityForButtonBar(isVisible: boolean, currentPageName:string){
        //visibility setzen
        if (this.actionBarVisibilityRegister[currentPageName]) {
            this.actionBar.classList.remove("w3-hide");
        } else {
            this.actionBar.classList.add("w3-hide");
        }
    }

    postCreate() {
        super.postCreate.apply(this, arguments as any);

        // cypress hook: Primaer-Menue-Toggle der Aktionsleiste stabil adressierbar machen (analog GenericDialog)
        this.btnPrimaryMenu.setAttribute("data-cy", "Button:primaryMenu");
        this.btnPrimaryMenu.setAttribute("data-e2e-role", "button");

        this.pages = [];
        this.dirtyPages = [];
        this.globalButtonEntries = [];

        this.addSubscription("/Tabbing/TabClosed", lang.hitch(this, this._onRequestTabclose));
        this.addSubscription("/Tabbing/NewTabRequest", lang.hitch(this, this._onRequestNewTab));
        this.addSubscription("/Tabbing/SwitchTabRequest", lang.hitch(this, this._onRequestSwitchTab));
        this.addSubscription("/Tabbing/ChangeTabTitleRequest", lang.hitch(this, this._onRequestTabRenameGlobal));
        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));
        this.addSubscription("sidebar/linksCreated", lang.hitch(this, this._onSidebarCreated));

        this._setNoTabsMessage();

        this.scrollEvent = lang.hitch(this, this._onWindowScroll);
        window.addEventListener("scroll", this.scrollEvent);

        this.on("switchPage", lang.hitch(this, this._onSwitchPageManageHideUnHideActionBar));
    }

    destroy() {

        window.removeEventListener("scroll", this.scrollEvent);
        UrlHelpers.removeUrlParameter("tc");
        super.destroy.apply(this, arguments as any);

    }

    startup() {
        super.startup.apply(this, arguments as any);


    }

    setCyAttribute(buttonConfig: any, parentPage: any, cyTitle: string, element: HTMLElement | null): void {
        if (!element) {
            return;
        }

        const label = buttonConfig?.label ?? "";

        const buttonLabel =
            label.trim() !== "" && !label.trim().startsWith("'<i") && !label.trim().startsWith("<i")
                ? label
                : "";

        const buttonName =
            buttonConfig?.name && buttonConfig.name !== ""
                ? buttonConfig.name
                : buttonLabel;

        // parentPage?.label bewusst NICHT verwenden: das ist der dynamische Seiten-/Projektname
        // (z.B. "e2e Projekt ...") und macht das data-cy instabil. Stabil bleibt section + cyTitle + buttonName.
        const dataCy = [
                        "Button",
                        this._sectionTitle,
                        cyTitle,
                        buttonName
                        ]
            .map(value => typeof value === "string" ? value.trim() : "")
            .filter(value => value !== "")
            .join(":");

        element.setAttribute("data-cy", dataCy);
    }

}

export default mdsWidget(TabContainer);
